/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Visa_O1_Extra_HeadingInputs */

const en_visa_o1_extra_heading = /** @type {(inputs: Visa_O1_Extra_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evidence Planning`)
};

const pt_visa_o1_extra_heading = /** @type {(inputs: Visa_O1_Extra_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Planejamento de Evidência`)
};

const es_visa_o1_extra_heading = /** @type {(inputs: Visa_O1_Extra_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Planificación de Evidencia`)
};

/**
* | output |
* | --- |
* | "Evidence Planning" |
*
* @param {Visa_O1_Extra_HeadingInputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const visa_o1_extra_heading = /** @type {((inputs?: Visa_O1_Extra_HeadingInputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Visa_O1_Extra_HeadingInputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_visa_o1_extra_heading(inputs)
	if (locale === "es") return es_visa_o1_extra_heading(inputs)
	return en_visa_o1_extra_heading(inputs)
});